import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Fragment, memo, useState } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './GiftGuide.module.scss';
import getRandomInt from '../../../utils/getRandomInt';
import useEventListener from '../../../utils/hooks/useEventListener';
import useTimeout from '../../../utils/hooks/useTimeout';
/* eslint-disable */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var cursorSvg = "<svg xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 28.83 46.58'><path d='m20.1 45.55a14 14 0 1 1 7.71-18.18 14 14 0 0 1 -7.71 18.18zm-9-22.35a10.14 10.14 0 1 0 13.21 5.61 10.15 10.15 0 0 0 -13.25-5.61z' /><path d='m0 20v-18.37l4-1.63 12.73 13.21-4 1.6-9.04-9.81.31 13.35z'/></svg>";
var cursorStyling = "\n  html, body, a, button, div {\n    cursor: url(\"data:image/svg+xml,".concat(cursorSvg, "\"), default;\n  }\n  ");
/* eslint-enable */

var MAX_STARS = 100; // in array

var MAX_STAR_DIST = 24; // dist away from cursor

var STAR_SHOW_DELAY = 20;
var Star = /*#__PURE__*/memo(function (_ref) {
  var degree = _ref.degree,
      left = _ref.left,
      top = _ref.top;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var style = {
    left: left,
    top: top,
    transform: "rotate(".concat(degree, "deg)")
  }; // show then hide after delay amount

  useTimeout(function () {
    setShow(true);
  }, STAR_SHOW_DELAY);
  return /*#__PURE__*/_jsx("div", {
    className: cc([css.star, _defineProperty({}, css.show, show)]),
    style: style,
    children: /*#__PURE__*/_jsx("p", {
      children: "*"
    })
  });
});
Star.propTypes = {
  degree: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  top: PropTypes.number.isRequired
};

var CustomCursor = function CustomCursor() {
  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      stars = _useState4[0],
      setStars = _useState4[1]; // array of star objects { top, left }


  useEventListener('mousemove', function (_ref3) {
    var clientX = _ref3.clientX,
        clientY = _ref3.clientY;

    // random chance to create star 1/10
    if (getRandomInt(10) !== 0) {
      return;
    }

    var newStars = stars.slice(); // gate number to max to not manage huge array

    if (newStars.length >= MAX_STARS) {
      newStars.shift();
    }

    var moveX = (getRandomInt(2) === 0 ? -1 : 1) * (getRandomInt(MAX_STAR_DIST) + MAX_STAR_DIST);
    var moveY = getRandomInt(MAX_STAR_DIST) + MAX_STAR_DIST;
    var left = clientX + moveX;
    var top = clientY + moveY;
    var degree = getRandomInt(360); // add new star object with coords

    newStars.push({
      key: "star-".concat(Math.random()),
      left: left,
      top: top,
      degree: degree
    });
    setStars(newStars);
  });
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("style", {
      dangerouslySetInnerHTML: {
        __html: cursorStyling
      }
    }), stars.map(function (star) {
      return /*#__PURE__*/_jsx(Star, _objectSpread({}, star), star.key);
    })]
  });
};

export default /*#__PURE__*/memo(CustomCursor);